import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import $rq from '@/api/api';
import type { AnalysisType } from '@/interfaces/common';

// Default state
const defaultState: AnalysisType = {} as AnalysisType;

const analysisTypeModule: Module<AnalysisType, RootState> = {
    state: () => ({ ...defaultState }),
    mutations: {
        setAnalysisTypeState(state: AnalysisType, analysisType: AnalysisType) {
            Object.assign(state, analysisType);
        },
        resetAnalysisTypeState(state: AnalysisType) {
            for (const key of Object.keys(state)) {
                delete (state as unknown as Record<string, unknown>)[key];
            }
        },
    },
    actions: {
        async getAnalysisTypeInfo({ commit, dispatch }, analysisTypeId: string) {
            try {
                const { data } = await $rq.getAnalysisType(analysisTypeId);
                commit('setAnalysisTypeState', data);
            } catch {
                dispatch('resetAnalysisTypeInfo');
            }
        },
        resetAnalysisTypeInfo({ commit }) {
            commit('resetAnalysisTypeState');
        },
    },
    getters: {
        analysisType: (state: AnalysisType) => state,
    },
};

export default analysisTypeModule;
